/*
*
* File JS per la Single Gallery
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroImage from 'imComponents/hero-image/hero-image';
import blockDownload from 'components/block-download/block-download';

// COMPONENTI CUSTOM BLOCKS - GALLERY
import blockText from 'components/block-text/block-text';
import blockEmbed from 'imComponents/block-embed/block-embed';
import blockVideo from 'imComponents/block-video/block-video';
import blockGalleryGrid from 'components/block-gallery-grid/block-gallery-grid';

// RELAZIONI
import bannerPlace from 'components/banner-place/banner-place';
import cardGuest from 'components/card-guest/card-guest';
import blockEventGuests from 'components/block-event-guests/block-event-guests';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './single-gallery.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

blockGalleryGrid();
blockVideo();

//--------------------------------------------------------------------//